import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  operationActive: false,
  operationSuccessful: true,
  isVisible: false,
}

export const modalFormSlice = createSlice({
  name: 'modalForm',
  initialState,

  reducers: {
    operationStart: (state, action) => {
      state.operationActive = true
    },

    operationEnd: (state, action) => {
      state.operationActive = false
      state.operationSuccessful = action.payload.successful
    },

    setVisible: (state, action) => {
      state.isVisible = action.payload
    },
  },
})

export const {
  operationStart,
  operationEnd,
  setVisible,
} = modalFormSlice.actions

export default modalFormSlice.reducer
